import React from 'react';
import PropTypes from 'prop-types';

const FilterSection = (props) => (
    <section className="sb-filter__section__wrapper" >
        <div className="sb-filter__section">
            <h4 className="sb-filter__header">{props.sectionName}</h4>
            {props.children}
        </div>
    </section>
);

FilterSection.propTypes = {
    sectionName: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};

export default FilterSection;



// WEBPACK FOOTER //
// ./src/client/components/FilterSection.js